import { CoreLibService } from './core-lib.service';
import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';


/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *hasAnyPermission="'id1'">...</some-element>
 *
 *     <some-element *hasAnyPermission="['id1', 'id2']">...</some-element>
 * ``
 */
@Directive({
    selector: '[hasAnyPermission]',
    standalone: false
})
export class HasAnyPermissionDirective {
  private permissions: string[];

  constructor(private coreLibService: CoreLibService, private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {}

  @Input()
  set hasAnyPermission(value: string | string[]) {
    this.permissions = typeof value === 'string' ? [value] : value;
    this.updateView();
    // Get notified each time authentication state changes.
    this.coreLibService.getUserChanges().subscribe(identity => this.updateView());
  }

  private updateView(): void {
    const hasAnyAuthority = this.coreLibService.hasAnyPermission(this.permissions);
    this.viewContainerRef.clear();
    if (hasAnyAuthority) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
